module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_IMMUNSYSTEM_kacheln-colostrumliquid.373e0ac9.png";